const HisMinimize = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg style={_sx} viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2858 4.5V8.5C11.2858 9.20724 11.0049 9.88552 10.5048 10.3856C10.0047 10.8857 9.32638 11.1667 8.61914 11.1667H4.61914"
        stroke={strokeColor}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.6188 11.1667H24.6188C23.9116 11.1667 23.2333 10.8857 22.7332 10.3856C22.2331 9.88552 21.9521 9.20724 21.9521 8.5V4.5"
        stroke={strokeColor}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.61914 21.8359H8.61914C9.32638 21.8359 10.0047 22.1169 10.5048 22.617C11.0049 23.1171 11.2858 23.7954 11.2858 24.5026V28.5026"
        stroke={strokeColor}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9521 28.5026V24.5026C21.9521 23.7954 22.2331 23.1171 22.7332 22.617C23.2333 22.1169 23.9116 21.8359 24.6188 21.8359H28.6188"
        stroke={strokeColor}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisMinimize;
